import { routes } from '../../router'
import { COGNUS_REPOSITORY_OPTIONS } from '../CognusRepository/constants'
import { PRS_DETAILS_TABS } from '../../pages/ProductRequests/constants'
import { contractCategoryDetailsRoute } from '../ContractCategoryDetails/routes'
import { FINANCIAL_TABS } from '../Financials/constants'
import { SplitFeesRouting } from '../Financials/SplitFees/constants'
import { RFP_DETAILS_TABS } from '../RFP/RFPDetails/constants'

export const NOTIFICATION_TYPE_TO_ROUTE = (
  id: string,
  canSeeMyContracts?: boolean
) => ({
  rfp_details_general_tab: `${routes.bidding}${routes.rfp}/${id}/${RFP_DETAILS_TABS[0].key}`,
  rfp_details_vendor_tab: `${routes.bidding}${routes.rfp}/${id}/${RFP_DETAILS_TABS[3].key}`,
  rfp_details_voting_tab: `${routes.bidding}${routes.rfp}/${id}/${RFP_DETAILS_TABS[4].key}`,
  rfp_details_bidding_tab: `${routes.bidding}${routes.rfp}/${id}/${RFP_DETAILS_TABS[5].key}`,
  rfp_result_tab: `${routes.bidding}${routes.rfp}/${id}/${RFP_DETAILS_TABS[6].key}`,
  clinical_review_tab: `${routes.contracts}${
    routes.centralRepository
  }/?redirectTab=${COGNUS_REPOSITORY_OPTIONS()[1].value}`,
  request_for_analysis_tab: `${routes.contracts}${routes.centralRepository}/${id}`,
  opportunity_analysis_tab: `${routes.contracts}${routes.opportunityAnalysis}/${id}`,
  available_for_evaluation_tab: `${routes.contracts}${
    routes.centralRepository
  }/?redirectTab=${COGNUS_REPOSITORY_OPTIONS()[0].value}`,
  hs_list_tab: `${routes.contracts}${routes.myContracts}/${id}/facilities`,
  chat_tab: `${routes.chat}/${id}`,
  contract_details_general_tab: `${routes.contracts}${
    canSeeMyContracts ? routes.myContracts : ''
  }/${id}`,
  prs_details_general_tab: `${routes.productRequests}/${id}/${PRS_DETAILS_TABS[0].key}`,
  prs_details_facilities_tab: `${routes.productRequests}/${id}/${PRS_DETAILS_TABS[1].key}`,
  prs_details_voting_tab: `${routes.productRequests}/${id}/${PRS_DETAILS_TABS[3].key}`,
  prs_details_result_tab: `${routes.productRequests}/${id}/${PRS_DETAILS_TABS[5].key}`,
  calendar_event_tab: `${routes.calendar}/?event_id=${id}`,
  contract_details_item_list_tab: `${routes.contracts}${
    canSeeMyContracts ? routes.myContracts : ''
  }/${id}/item_list`,
  contract_category_details_general_tab: `${routes.contracts}${routes.contractCategories}/${id}/${contractCategoryDetailsRoute.general}`,
  financials_rebates_tab: `${routes.financials}/${FINANCIAL_TABS[0].key}`,
  financials_rebates_invoice_details_tab: `${routes.financials}/${FINANCIAL_TABS[0].key}?invoiceId=${id}`,
  financials_marketplace_ar_tab: `${routes.financials}/${FINANCIAL_TABS[2].key}`,
  financials_qsight_processing_fee_tab: `${routes.financials}/${FINANCIAL_TABS[3].key}/${SplitFeesRouting.processing}`,
  financials_admin_accounts_payable_tab: `${routes.financials}/${FINANCIAL_TABS[1].key}?isPayable=true`,
  financials_admin_tab: `${routes.financials}/${FINANCIAL_TABS[1].key}`,
  my_community_user_profile_tab: `${routes.myCommunity}${routes.profile}/${id}`,
  financials_split_fees_tab: `${routes.financials}/${FINANCIAL_TABS[3].key}/${SplitFeesRouting.community}`,
  financials_marketplace_ar_invoice_details_tab: `${routes.financials}/${FINANCIAL_TABS[2].key}?invoiceId=${id}`
})
